module.exports = __webpack_public_path__ + "img/icon-depos.fea80a06.png";